module.exports = new __parcel__URL__("empty-no-search-results-v2.a81f25f1.svg").toString();